import React, { useEffect, useState } from "react"
import { Routes, Route, Navigate, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { useStateContext } from "./components/contexts/ContextProvider"
import LoginScreen from "./loginSignup/LoginScreen"
import RouteIndex from "./routes/RouteIndex"
import Tostify from "./components/UI/ToastifyNotify/Tostify"
import logo from "./components/asserts/Spin.gif"

import { connectSSE } from "./utils/sseService"
import { getUserStatus } from "./axios/api/apiModule"
import { userAction } from "./components/store/actions/userAction"
import { REDUX_STORE_DEFAULTS } from "./components/store/config"

function App() {
  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext()
  const { userData } = useSelector((state) => state.userReducer)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoader, setIsLoader] = useState(true)
  const dispatch = useDispatch()

  const location = useLocation()

  // theme init
  useEffect(() => {
    const color = localStorage.getItem("colorMode")
    const mode = localStorage.getItem("themeMode")
    if (color && mode) {
      setCurrentColor(color)
      setCurrentMode(mode)
    }
  }, [])

  // auth check
  useEffect(() => {
    const userStr = localStorage.getItem("user")
    const userData = userStr ? JSON.parse(userStr) : null
    const token = userData?.jwtToken

    const checkAuth = async () => {
      if (!token) {
        setIsAuthenticated(false)
        setIsLoader(false)
        return
      }

      try {
        const res = await getUserStatus({ jwtToken: token })
        if (res.success) {
          setIsAuthenticated(true)
          connectSSE(token)
          // dispatch(
          //   userAction(REDUX_STORE_DEFAULTS.UPDATE_LOGIN_USER(), userData),
          // )
        } else {
          setIsAuthenticated(false)
        }
      } catch {
        setIsAuthenticated(false)
      } finally {
        setIsLoader(false)
      }
    }

    checkAuth()
    console.log(userData, "userData")
  }, [userData])

  if (isLoader) {
    return (
      <div className="fixed bg-black w-full h-full flex items-center justify-center">
        <img src={logo} alt="Loading" className="w-[5rem] h-[5rem]" />
        <span className="text-white ml-3">Loading</span>
      </div>
    )
  }

  return (
    <>
      <Tostify />

      <Routes>
        {/* LOGIN */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/calendar" replace />
            ) : (
              <LoginScreen />
            )
          }
        />

        {/* PROTECTED APP */}
        <Route
          path="/*"
          element={
            isAuthenticated ? <RouteIndex /> : <Navigate to="/" replace />
          }
        />
      </Routes>
    </>
  )
}

export default App
